import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { map } from 'rxjs/operators';
import { loaderTypes } from '@app/shared/component/loader/loader';

@Injectable({
  providedIn: 'root',
})
export class NetworkSetupNavService {
  constructor(private readonly httpService: AmplifyHttpClient) {}
  isOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);
  allStepsDataObservable: BehaviorSubject<any> = new BehaviorSubject(null);
  completedItemsObservable: BehaviorSubject<any> = new BehaviorSubject(null);

  handleNav(val: boolean) {
    this.isOpened.next(val);
  }

  getNetworkSetup(type: 'family' | 'friends' | 'professional' | 'admins') {
    return this.httpService.get<any>(`api/user/network-status/${type}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateNetworkSetup(params) {
    return this.httpService.post<any>(`api/user/network-status`, params, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getNetworkPathStatus() {
    return this.httpService.get<any>(`api/user/network-path-status-count`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateNetworkStatus(data: { status: 'complete'; type: 'friends' | 'family' | 'professional' | 'admins'; user_id: any }) {
    return this.httpService.post<any>(`api/user/network-path-status`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
